/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { JobExecutionStatus } from '../../../../Services/job-runner';

/**
 * Get the formatted status value.
 * @param {JobExecutionStatus} status The status value to be formatted.
 * @returns {string} The formatted status.
 */
export const getFormattedStatus = (status: JobExecutionStatus): string => {
  const capitalised = `${status.charAt(0).toUpperCase()}${status.slice(1)}`;
  return capitalised.replace(/-/g, ' ');
};
